
import { creditorService } from '../services';
import baseMethods from './base';

const initialState = {  creditors: {data: null,status:{ loading: false,ready: false }},
                        singleCreditor: {data: null,status:{ loading: false,ready: false }}
                     };

export const creditor = {
    namespaced: true,
    state: initialState,
    actions: {
        getCreditors({ commit } )
        {
            commit('getCreditorsRequest' );
            return new Promise((resolve, reject) => {

                creditorService.getCreditors().then(
                    response => {
                        
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getCreditorsSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getCreditorsFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        getCreditor({ commit }, id)
        {
            commit('getCreditorRequest' );
            return new Promise((resolve, reject) => {

                creditorService.getCreditor(id).then(
                    response => {
                        
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getCreditorSuccess',response.data);
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getCreditorFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        }, 
        getCreditorArticles({ commit }, id)
        {
            commit('getCreditorArticlesRequest' );
            return new Promise((resolve, reject) => {

                creditorService.getCreditorArticles(id).then(
                    response => {
                        
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('getCreditorArticlesSuccess',{id:id, data:response.data});
                            resolve(response.data);
                        }
                        else
                        {
                            commit('getCreditorArticlesFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        }, 
        saveCreditor({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertCreditorRequest' );
                    creditorService.insertCreditor(data).then(
                        response => {

                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertCreditorSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertCreditorFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updateCreditorRequest' );
                    creditorService.updateCreditor(data).then(
                        response => {
                            
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updateCreditorSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updateCreditorFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        },
        saveCreditorArticle({ commit }, data)
        {
            return new Promise((resolve, reject) => {
                
                if(data.id <= 0)
                {
                    commit('insertCreditorArticleRequest' );
                    creditorService.insertCreditorArticle(data).then(
                        response => {

                            if(baseMethods.IsSuccess(response))
                            {
                                commit('insertCreditorArticleSuccess');
                                resolve(response.data);
                            }
                            else
                            {
                                commit('insertCreditorArticleFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
                else
                {
                    commit('updateCreditorArticleRequest' );
                    creditorService.updateCreditorArticle(data).then(
                        response => {
                            
                            if(baseMethods.IsSuccess(response))
                            {
                                commit('updateCreditorArticleSuccess',data);
                                resolve(response.data);
                            }
                            else
                            {
                                commit('updateCreditorArticleFailure');
                                reject(response.statusText);
                            }
                        }
                    );
                }
            })
        },        
        deleteCreditor({ commit },id )
        {
            commit('deleteCreditorRequest' );
            return new Promise((resolve, reject) => {

                creditorService.deleteCreditor(id).then(
                    response => {
                        
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deleteCreditorSuccess');
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deleteCreditorFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },
        deleteCreditorArticle({ commit },id )
        {
            commit('deleteCreditorArticleRequest' );
            return new Promise((resolve, reject) => {

                creditorService.deleteCreditorArticle(id).then(
                    response => {
                        
                        if(baseMethods.IsSuccess(response))
                        {
                            commit('deleteCreditorArticleSuccess');
                            resolve(response.data);
                        }
                        else
                        {
                            commit('deleteCreditorArticleFailure');
                            reject(response.statusText);
                        }
                    }
                );

            })
        },

    },
    mutations: {
        getCreditorsRequest(state)
        {
            state.creditors = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getCreditorsSuccess(state, data)
        {
            state.creditors = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getCreditorsFailure(state)
        {
            state.creditors = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },

        getCreditorRequest(state)
        {
            state.singleCreditor = {
                data: null,
                status:{ loading: true,ready: false }
            };
        },
        getCreditorSuccess(state, data)
        {
            state.singleCreditor = {
                data: data,
                status:{ loading: false,ready: true }
            };
        },
        getCreditorFailure(state)
        {
            state.singleCreditor = {
                data: null,
                status:{ loading: false,ready: false }
            };
        },
        getCreditorArticlesRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        getCreditorArticlesSuccess(state,data)
        {
            state.creditors.status = { loading: false,ready: true };

            for(let i = 0; i < state.creditors.data.length; i++)
            {
                if(state.creditors.data[i].id == data.id)
                {
                                               alert(data.id);
                            alert(JSON.stringify(data));

                    state.creditors.data[i].articles = [];
                    state.creditors.data[i].articles = data.data;
                    break;
                }
            }
        },
        getCreditorArticlesFailure(state)
        {
            state.creditors.status = { loading: false,ready: true };
        },        
        insertCreditorRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        insertCreditorSuccess(state)
        {
            state.creditors.status = { loading: false,ready: true };
        },
        insertCreditorFailure(state)
        {
            state.creditors.status = { loading: false,ready: false };
        },
        updateCreditorRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        updateCreditorSuccess(state, data)
        {
            for(var i = 0; i < state.creditors.data.length; i++)
            {
                if(state.creditors.data.id == data.id)
                {
                    state.creditors.data[i] = data;
                    break;
                }
            }
            state.creditors.status = { loading: false,ready: true };
        },
        updateCreditorFailure(state)
        {
            state.creditors.status = { loading: false,ready: false };
        },
        insertCreditorArticleRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        insertCreditorArticleSuccess(state)
        {
            state.creditors.status = { loading: false,ready: true };
        },
        insertCreditorFArticleailure(state)
        {
            state.creditors.status = { loading: false,ready: false };
        },
        updateCreditorArticleRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        updateCreditorArticleSuccess(state)
        {
            state.creditors.status = { loading: false,ready: true };
        },
        updateCreditorArticleFailure(state)
        {
            state.creditors.status = { loading: false,ready: false };
        },        
        deleteCreditorRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        deleteCreditorSuccess(state)
        {
            state.creditors.status = { loading: false,ready: true };
        },
        deleteCreditorFailure(state)
        {
            state.creditors.status = { loading: false,ready: false };
        },
        deleteCreditorArticleRequest(state)
        {
            state.creditors.status = { loading: true,ready: false };
        },
        deleteCreditorArticleSuccess(state)
        {
            state.creditors.status = { loading: false,ready: true };
        },
        deleteCreditorArticleFailure(state)
        {
            state.creditors.status = { loading: false,ready: false };
        }
    }
}
